import { render } from "./TogglePlayButton.vue?vue&type=template&id=773ddef0&scoped=true"
import script from "./TogglePlayButton.vue?vue&type=script&lang=ts"
export * from "./TogglePlayButton.vue?vue&type=script&lang=ts"

import "./TogglePlayButton.vue?vue&type=style&index=0&id=773ddef0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-773ddef0"

export default script